import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import PartyCombobox from '../../../Combobox/PartyCombobox'
import { PartyType } from '../../Party/PartyForm'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export type PartyCardReportDto = {
    partyId: string
}

function ReportBody(props: ReportFormType): ReactElement {
    const { values, setFieldValue } = useFormikContext<PartyCardReportDto>()

    return (
        <PartyCombobox
            required
            multiselect={false}
            selectedOptions={[values.partyId]}
            onOptionSelect={(_, data) => setFieldValue('partyId', data.selectedOptions?.[0])}
            filter={entity => entity.type === PartyType.Legal}
        />
    )
}

export default function PartyCardReportForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<PartyCardReportDto>
            title="Clientenkaart"
            generationType={DocumentGenerationType.PartyCard}
            initialValues={{ partyId: undefined }}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
